import { render, staticRenderFns } from "./OpenCartShippingDetails.vue?vue&type=template&id=691331e3&"
import script from "./OpenCartShippingDetails.vue?vue&type=script&lang=js&"
export * from "./OpenCartShippingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartShippingDetails.vue"
export default component.exports